export default "__VITE_ASSET__hhP4zPlO__"